import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Pagos from "../components/finanzas/Pagos";
import Montos from "../components/finanzas/Montos";
import { PagosContext } from "../context/PagosContext";
import Preciario from "../components/finanzas/Preciario";
import { MontosContext } from "../context/MontosContext";
import { PreciarioContext } from "../context/PreciarioContext";
import { ContratosContext } from "../context/ContratosContext";
import ContratoForm from "../components/finanzas/ContratoForm";
import { ModalContext } from "../context/ModalContext";
import { ProyectosContext } from "../context/ProyectosContext";
import { isCoordinador } from "../utils/permisos";
import { DestajosContext } from "../context/DestajosContext";
import { CapacitorContext } from "../context/CapacitorContext";
import useProyecto from "../hooks/useProyecto";
import PillTabs from "../components/common/PillTabs";
import MobileTabs from "../components/movil/MobileTabs";
import usePreciario from "../hooks/usePreciario";
import Estimaciones from "../components/estimaciones/Estimaciones";
import OrdenesCambio from "./OrdenesCambio";

const tabs = [
  {
    label: "Catálogo",
    value: "catalogo",
  },
  {
    label: "Estimaciones",
    value: "estimaciones",
  },
  {
    label: "Pagos",
    value: "pagos",
  },
  {
    label: "Cambios",
    value: "cambios",
  },
];

const SingleContrato = () => {
  const { proyecto, getSingleProyecto } = useContext(ProyectosContext);
  const { contrato, selectContrato } = useContext(ContratosContext);
  const { montos, getMontosContrato } = useContext(MontosContext);
  const { pagos, getPagosContrato } = useContext(PagosContext);
  const { modalComponent } = useContext(ModalContext);
  const { getDestajos } = useContext(DestajosContext);
  const { editMode } = useContext(PreciarioContext);
  const { platform } = useContext(CapacitorContext);
  const { view, setView } = usePreciario();
  const { idProyecto } = useProyecto();
  const { idContrato } = useParams();

  useEffect(() => {
    getSingleProyecto(idProyecto);
    getDestajos(idProyecto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto]);

  useEffect(() => {
    getMontosContrato(idProyecto, idContrato);
    getPagosContrato(idProyecto, idContrato);
    selectContrato(idProyecto, idContrato);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto, idContrato]);

  const handleEdit = () => {
    modalComponent("Editar Contrato", <ContratoForm />);
  };

  const renderTitle = () => {
    if (contrato && contrato !== null && platform === "web") {
      return (
        <div className="row align-items-center my-2">
          <div className="col-10">
            <h2 className="h4 mb-0">Contrato #{contrato.folio || contrato.idContrato}</h2>
          </div>
          <div className="col-2 text-end">
            {isCoordinador(proyecto) && (
              <button className="btn btn-outline-primary" onClick={handleEdit}>
                <i className="fa fa-edit"></i>
              </button>
            )}
          </div>
        </div>
      );
    }
  };

  const renderMontos = () => {
    if (montos !== null && Array.isArray(pagos)) {
      return <Montos />;
    }
  };

  const renderView = () => {
    if (proyecto !== null) {
      if (view === "pagos") {
        return (
          <Pagos
            idProyecto={idProyecto}
            idContrato={idContrato}
            editMode={editMode}
          />
        );
      }
      if (view === "estimaciones") {
        return <Estimaciones />;
      }
      if (view === "cambios") {
        return <OrdenesCambio />;
      }
      return <Preciario idContrato={idContrato} idProyecto={idProyecto} />;
    }
  };

  return (
    <div className="container-fluid overflow-y-auto pb-5">
      {renderTitle()}
      {renderMontos()}
      <div className="container-fluid mb-3 px-0 mt-3">
        {platform === "web" ? (
          <div className="card p-3 px-4 shadow">
            <PillTabs
              tabs={tabs}
              value={view}
              modifier={(value) => setView(value)}
            />
          </div>
        ) : (
          <MobileTabs
            tabs={tabs}
            value={view}
            modifier={(value) => setView(value)}
          />
        )}
      </div>
      {renderView()}
    </div>
  );
};

export default SingleContrato;
